var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showBanner)?_c('router-link',{staticClass:"offline-banner text-center white-text",attrs:{"to":{name:'settings.offline'}}},[_c('p',{staticClass:"z-depth-1"},[_vm._v("You're in "),_c('strong',[_vm._v("encrypted offline mode")])])]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e921d5e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OfflineMode.vue
// module id = gYtk
// module chunks = 1